import { decodeJwt } from 'jose';
import { getJwtToken } from './session-storage';
// import { createRemoteJWKSet } from 'jose/jwks/remote';

// Function to decode a JWT token
export function decodeToken(token) {
  try {
    const decodedToken = decodeJwt(token ? token : getJwtToken());
    return decodedToken;
  } catch (error) {
    return null;
  }
}

// Function to check if a JWT token is valid
export async function isValidJWT(token, jwksUri) {
  try {
    // Fetch the JWKS (JSON Web Key Set) from the provided URI
    const remoteJWKS = createRemoteJWKSet(new URL(jwksUri));

    // Verify the JWT token's signature using the fetched JWKS
    await verify(token, remoteJWKS);

    // If verification is successful, the token is valid
    return true;
  } catch (error) {
    console.error('Error validating JWT token:', error.message);
    return false;
  }
}
